const ADMINISTRATIVE_PROMPT_FIELDS = new Set([
  'carePathway',
]);

/**
 * Retire les informations qui organisent le dossier mais ne doivent jamais
 * devenir un signal clinique ou commercial dans un prompt IA.
 */
export function stripAdministrativePromptFields(form = {}) {
  if (!form || typeof form !== 'object' || Array.isArray(form)) return {};
  return Object.fromEntries(
    Object.entries(form).filter(([key]) => !ADMINISTRATIVE_PROMPT_FIELDS.has(key)),
  );
}
